<template>
  <div class="tuihuo">
    <div v-if="!pupopShow" style="width: 95%; margin: auto">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            style="display: flex"
            class="t_search_form"
            label-position="left"
            label-width="90px"
          >
            <el-form-item label="退货入库编号:" label-width="100px">
              <el-input
                v-model="searchForm.thckBh"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="化学品:" label-width="90px">
              <el-input
                v-model="searchForm.hxpMc"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="入库日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.beginRkrq"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="startTime"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.endRkrq"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="endTime"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="状态:" label-width="50px">
              <el-select v-model="searchForm.zt" placeholder="">
                <el-option
                  v-for="(item, index) in statusList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-button
              v-preventReClick
              class="sousuoButton"
              icon="el-icon-search"
              round
              size="small"
              type="primary"
              @click="outhandleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              v-preventReClick
              class="chongzhiButton"
              size="small"
              icon="el-icon-refresh-right"
              round
              @click="reset"
            >重置</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;
          margin-left: auto;
          margin-right: auto;
        "
      >
        <div
          style="
            width: 90%;
            margin: auto;
            background-color: #f4f4f4;
            padding: 12px 10px;
            border: 1px solid #f4f4f4;
          "
        >
          <el-button
            v-preventReClick
            type="primary"
            class="addButton"
            style="border: none"
            size="mini"
            icon="el-icon-plus"
            @click="addPupShow(0)"
          >新增</el-button>
          <el-button
            v-preventReClick
            size="mini"
            icon="el-icon-plus"
            @click="copyAdd"
          >复制新增</el-button>
          <el-button
            v-preventReClick
            icon="el-icon-upload2"
            size="mini"
            @click="dcexcel"
          >导出</el-button>
        </div>
        <div class="tablemes">
          <el-table
            ref="cktable"
            :data="thrkTable"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
            :header-cell-class-name="cellClass"
            @selection-change="handleSelectionChange"
            @select-all="checkSelect"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
            />
            <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              label="入库编号"
              prop="rkbh"
            />
            <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              label="化学品名称"
              prop="hxpMc"
            />
            <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              label="仓库名称"
              prop="ckmc"
            /><el-table-column
              :show-overflow-tooltip="true"
              align="center"
              label="入库数量"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.rksl + scope.row.rkslDwLabel }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              label="入库日期"
              prop="rkrq"
            /><el-table-column
              :show-overflow-tooltip="true"
              align="center"
              label="登记日期"
              prop="djsj"
            />
            <el-table-column align="center" prop="bgcs" label="变更次数">
              <template slot-scope="scope">
                <span
                  v-preventReClick
                  style="cursor: pointer"
                  @click="bgcsClick(scope.row)"
                >{{ scope.row.bgcs }}</span>
              </template>
            </el-table-column>

            <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              label="状态"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.zt == '01'" style="color: #6fc89a">{{
                  scope.row.ztLabel
                }}</span>
                <span v-if="scope.row.zt == '11'" style="color: #43a5e2">{{
                  scope.row.ztLabel
                }}</span>
                <span v-if="scope.row.zt == '00'" style="color: #333333">{{
                  scope.row.ztLabel
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.zt != '00'"
                  v-preventReClick
                  type="primary"
                  icon="el-icon-document"
                  size="mini"
                  @click="addPupShow(2, scope.row)"
                >查看</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="addPupShow(3, scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  type="primary"
                  class="deleteButton"
                  icon="el-icon-delete"
                  size="mini"
                  @click="deleteItem(scope.row)"
                >删除</el-button>
                <el-button
                  v-if="scope.row.zt != '00'"
                  v-preventReClick
                  :type="scope.row.zt == '11' ? 'info' : 'warning'"
                  :disabled="scope.row.zt == '11'"
                  icon="el-icon-edit"
                  size="mini"
                  @click="addPupShow(4, scope.row)"
                >变更</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :current-page="outCurrentPage"
            :page-size="outPageSize"
            :page-sizes="[10, 20]"
            :total="outTotal"
            class="el-page"
            @size-change="outpagesizeChange"
            @current-change="outhandleCurrentChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <returnGoodsPup
      v-if="pupopShow"
      ref="thrkProp"
      :djrqdisable="djrqdisable"
      :bgdisable="bgdisable"
      :cur-row-objthrk="curRowObjthrk"
      :children-type="childrenType"
      :checkshow="checkshow"
    />
  </div>
</template>
<script>
import returnGoodsPup from '@/components/thrg/returnGoodsPup'
import bgcs from '@/components/bgcs'
import {
  getThrkList,
  getThrkdetail,
  excelwriter,
  deleteThrk,
  getRkStatus
} from '@/assets/js/thrk.js'
export default {
  components: { returnGoodsPup, bgcs },
  props: {},
  data() {
    return {
      curRowObjthrk: {},
      bgcsTKName: '退货入库',
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.endRkrq) {
            return time.getTime() > new Date(this.searchForm.endRkrq).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.beginRkrq) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.searchForm.beginRkrq).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      bgwindow: false,
      // 登记日期
      djrqdisable: false,
      // 查看禁用
      checkshow: false,
      // 变更禁用
      bgdisable: false,
      pupopShow: false,
      childrenType: '', // 子组件操作类型
      multipleSelection: [],
      /* 搜索表单 */
      statusList: [], // 状态下拉
      searchForm: {
        thckBh: '',
        hxpMc: '',
        beginRkrq: '',
        endRkrq: '',
        zt: ''
      },
      /* 退货入库列表分页属性 */
      outCurrentPage: 1,
      outPageSize: 10,
      outTotal: 0,
      thrkTable: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.loadDataSource()
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 点击变更次数
    bgcsClick(curRow) {
      // this.curRowObj = curRow;
      this.$bus.emit('bgcsOpen', curRow, '9')
      this.bgwindow = curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 导出
    dcexcel() {
      this.$confirm('是否导出退货入库信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          excelwriter({
            param: {
              thckBh: this.searchForm.thckBh,
              hxpMc: this.searchForm.hxpMc,
              beginRkrq: this.searchForm.beginRkrq,
              endRkrq: this.searchForm.endRkrq,
              zt: this.searchForm.zt
            }
          }).then((e) => {
            const table = '退货入库'
            const a = document.createElement('a')
            const blob = new Blob([e.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    loadDataSource() {
      this.search()
      getRkStatus().then((e) => {
        this.statusList = e.data.data
      })
    },
    // 外部分页方法
    outpagesizeChange(val) {
      this.outPageSize = val
      this.search()
    },
    outhandleCurrentChange(val) {
      this.outCurrentPage = val
      this.search()
    },
    reset() {
      this.searchForm.thckBh = ''
      this.searchForm.hxpMc = ''
      this.searchForm.beginRkrq = ''
      this.searchForm.endRkrq = ''
      this.searchForm.zt = ''
      this.outCurrentPage = 1
      this.outPageSize = 10
      this.search()
    },
    // 搜索外部列表
    search() {
      getThrkList({
        page: this.outCurrentPage,
        size: this.outPageSize,
        param: {
          thrkBhLike: this.searchForm.thckBh,
          hxpMc: this.searchForm.hxpMc,
          beginRkrq: this.searchForm.beginRkrq,
          endRkrq: this.searchForm.endRkrq,
          zt: this.searchForm.zt
        }
      }).then((e) => {
        this.thrkTable = e.data.data.rows
        this.outTotal = e.data.data.total
      })
    },
    // 删除记录
    deleteItem(row) {
      this.$confirm('是否删除本条退货入库信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteThrk(row.id).then((e) => {
            if (e.data.code == '000000') {
              this.search()
              this.$message({
                message: '删除成功!',
                type: 'success'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 表格
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.cktable.clearSelection()
        this.$refs.cktable.toggleRowSelection(val.pop())
      }
    },
    checkSelect(selection) {
      this.$refs.cktable.clearSelection()
    },
    // 取消全选框
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disableheadselection'
      }
    },
    // 复制新增
    copyAdd() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: 'info',
          message: '请选择一条数据'
        })
      } else {
        this.ckdisable = false
        this.djsjshow = false
        this.bgdisable = false
        this.pupopShow = true
        this.childrenType = 'copy'
        getThrkdetail(this.multipleSelection[0].id).then((e) => {
          this.$refs.thrkProp.loadData(e.data.data)
        })
        this.checkedTableList = []
      }
    },
    // 根据操作类型调用子组件
    addPupShow(type, row) {
      this.curRowObjthrk = row
      this.pupopShow = true
      if (type == 0) {
        // 新增
        this.djrqdisable = false
        this.checkshow = false
        this.bgdisable = false
        this.childrenType = 'add'
      } else if (type == 2) {
        // 查看
        this.djrqdisable = true
        this.checkshow = true
        this.bgdisable = false
        this.childrenType = 'ck'
        getThrkdetail(row.id).then((e) => {
          this.$refs.thrkProp.form = e.data.data
        })
      } else if (type == 3) {
        // 编辑
        this.djrqdisable = true
        this.checkshow = false
        this.bgdisable = false
        this.childrenType = 'bj'
        getThrkdetail(row.id).then((e) => {
          this.$refs.thrkProp.loadData(e.data.data)
        })
      } else if (type == 4) {
        // 变更
        this.djrqdisable = true
        this.checkshow = false
        this.bgdisable = true
        this.childrenType = 'bg'
        getThrkdetail(row.id).then((e) => {
          this.$refs.thrkProp.loadData(e.data.data)
          this.$delete(this.$refs.thrkProp.form, 'bgly')
        })
      }
    }
  }
}
</script>
<style scoped lang='less'>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/.el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 32px;
  width: 30px !important;
  color: #303133;
}
.addButton {
  color: #fff;
  background: #4170ff;
  border-radius: 3px;
  border-color: #4170ff;
}
.tuihuo {
  // height: 100%;
  .headerSearch {
    max-width: 1518px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        // width: 90px;
        // height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none !important;
}
</style>
